import React from 'react'
import { Link } from "react-router-dom";
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_48_0 = () => {
  return (
    <div>
      <PageTitle title='3.48.0' />

      <ParaTitle paraTitle='Bug Fixes' />
      <Paragraph paragraph='2026-01-31' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Expand Facility Report User List
          <p>Organization managers and users with the Risk Manager role will now receive the weekly facility report reminder sent every Monday, helping them stay up to date on facility status.</p>
        </li>
        <li>
          Writing Brief Description Instruction
          <p>Writing a comprehensive event brief description helps strengthen and promote a positive safety culture. Clear instructions have been added to the tutorial to guide users in preparing detailed and effective descriptions. </p>
          <p>Please see here - <Link to="/general/writing-brief-description">Writing Brief Description</Link></p>
        </li>
        <li>
          Limit Emails in Settings
          <p>Users can now customize and limit the types of emails they receive, giving them greater control over system notifications and reducing unnecessary messages.</p>
        </li>
        <li>Able to Search through Comments
          <p>Important details are often added in the comments after an event is created, especially when certain information is not available while the event is still open. Enabling comment search will help users find this information more efficiently.</p>
        </li>
        <li>Enhance Search in the Answers Column
          <p>Improve the search functionality by enabling users to search directly within the Answers column, making it easier to locate relevant information.</p>
        </li>
      </ul>

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Upgrading Server
            <p>Complete the upgrade to the latest Ubuntu LTS release. This process includes validating that all Docker containers continue to function properly and that hosted websites remain accessible.</p>
            <p>Testing will ensure that Docker services operate as expected and are able to connect to all required dependencies and resources.</p>
        </li>
      </ul>

      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
          Help Desk Ticket Bug Fixes
          <p>.</p>
        </li>
      </ul>
      <Pagination
        pagination={{
          prev: { name: 'Updates: 3.49.0', link: '/updates/3.49.0' },
          next: { name: 'Updates: 3.47.0', link: '/updates/3.47.0' }
        }}
      />
    </div>

  )
}

export default Updates_3_48_0;